import Vue from 'vue'
import App from './App.vue'
import $axios from './assets/request'

Vue.config.productionTip = false
Vue.use($axios)
new Vue({
  render: h => h(App),
}).$mount('#app')
